export const PICKUP = "PICKUP";

export const COURIER_OPTIONS = [
    { value: null, text: "-- Pilih Kurir --" },
    { value: "BRINKS", text: "BRINKS" },
    { value: "PAXEL", text: "Paxel" },
    { value: PICKUP, text: "Pickup" }
];

export const courierLabel = value => {
    const opt = COURIER_OPTIONS.find(o => o.value && o.value === value);
    return opt ? opt.text : value || "-";
};

export const REQUEST_STATUS = {
    PENDING: 1,
    APPROVED: 2,
    CANCELLED: 3,
    PROCESSED: 4,
    // PO approved by PEI, waiting for SM.
    PEI_APPROVED: 5,
    // Everything requested was received by PEI.
    COMPLETED: 6
};

// PO: PENDING PEI -> PENDING (waiting SM) -> DISETUJUI. Non-PO: PENDING -> DISETUJUI.
export const requestStatusBadge = (status, isPo) => {
    const [variant, label] = {
        [REQUEST_STATUS.PENDING]: ["warning", isPo ? "PENDING PEI" : "PENDING"],
        [REQUEST_STATUS.PEI_APPROVED]: ["warning", "PENDING"],
        [REQUEST_STATUS.APPROVED]: ["success", "DISETUJUI"],
        [REQUEST_STATUS.PROCESSED]: ["info", "DIPROSES"],
        [REQUEST_STATUS.CANCELLED]: ["danger", "DIBATALKAN"],
        [REQUEST_STATUS.COMPLETED]: ["dark", "SELESAI"]
    }[status] || ["secondary", "Tidak Diketahui"];
    return { variant, label, class: "text-white" };
};

export const BOX_STATUS = { CREATED: 1, SENT: 2, RECEIVED: 3 };

export const boxStatusBadge = status =>
    ({
        [BOX_STATUS.CREATED]: ["warning", "DIBUAT"],
        [BOX_STATUS.SENT]: ["info", "DIKIRIM"],
        [BOX_STATUS.RECEIVED]: ["success", "DITERIMA"]
    }[status] || ["light", "Tidak Diketahui"]);
